<template>
    <div class="map-container">
      <!-- Search Input and Button -->
      <input
        type="text"
        v-model="searchQuery"
        placeholder="Search for an address"
        @keydown.enter="searchAddress"
        class="search-bar"
      />
      <button @click="searchAddress" class="search-button">Search</button>
  
      <!-- Map container -->
      <div id="map"></div>
    </div>
  </template>
  
  
  <script>
import L from "leaflet"; // Ensure you have Leaflet installed
import axios from "axios"; // For making HTTP requests (you can also use fetch if preferred)

export default {
  name: "Map",
  props: {
    locationChanged: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      map: null,
      marker: null,
      searchQuery: "", // To bind the search query input
    };
  },
  mounted() {
    // Initialize map centered at (0,0) by default
    this.map = L.map("map").setView([0, 0], 2);

    // Add OpenStreetMap tiles
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
    }).addTo(this.map);

    // Handle map click event (to add a marker)
    this.map.on("click", this.addMarker);
  },
  methods: {
    // Method to add a marker when clicking on the map
    addMarker(event) {
      const { lat, lng } = event.latlng;

      // If marker exists, move it; otherwise, create a new one
      if (this.marker) {
        this.marker.setLatLng([lat, lng]);
      } else {
        this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);

        // Listen for drag end on the marker
        this.marker.on("dragend", () => {
          const position = this.marker.getLatLng();
          this.updateLocation(position.lat, position.lng);
        });
      }

      // Emit updated location to the parent component
      this.updateLocation(lat, lng);
    },

    // Method to search for an address and update the map
    async searchAddress() {
      if (!this.searchQuery) return;

      // Make a geocoding request to get coordinates for the search query
      try {
        const response = await axios.get(
          `https://nominatim.openstreetmap.org/search`,
          {
            params: {
              q: this.searchQuery,
              format: "json",
              addressdetails: 1,
              limit: 1,
            },
          }
        );

        if (response.data && response.data[0]) {
          const { lat, lon } = response.data[0];
          this.map.setView([lat, lon], 15); // Set map to the new location

          // If a marker exists, move it; otherwise, add a new one
          if (this.marker) {
            this.marker.setLatLng([lat, lon]);
          } else {
            this.marker = L.marker([lat, lon], { draggable: true }).addTo(this.map);
          }

          // Emit the updated location to the parent component
          this.updateLocation(lat, lon);
        } else {
          alert("Address not found!");
        }
      } catch (error) {
        console.error("Error searching address:", error);
      }
    },

    // Method to emit location to the parent component
    updateLocation(lat, lng) {
      this.$emit("locationChanged", { lat, lng });
    },
  },
};
</script>

  
<style scoped>
.search-bar {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.search-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s ease;
}

.search-button:hover {
  background-color: #0056b3;
}

#map {
  width: 100%;
  height: 400px;
  border-radius: 8px;
}
</style>
